<script>
import { mapActions, mapState } from 'vuex';
import mainViewTabMixin from '../../mixins/mainViewTab';
import paginationMixin from '../../mixins/pagination';
import QuestionaryListItem from './components/QuestionaryListItem';
import NewQuestionaryDialog from './components/NewQuestionaryDialog';

export default {
  name: 'QuestionaryList',
  components: {
    QuestionaryListItem,
    NewQuestionaryDialog,
  },
  mixins: [mainViewTabMixin, paginationMixin],
  data() {
    return {
      isInitialized: false,
      headers: [{ text: 'Bezeichnung', value: 'name' }, { text: 'Kategorie', value: 'categoryName' },
        { text: 'Aktionen', value: '' }],
      isNewQuestionaryDialogDisplayed: false,
    };
  },
  computed: {
    ...mapState(['questionaryList']),
    ...mapState('questionaryList', ['meta']),
  },
  mounted() {
    this.fetchData(this.paginationParams).then(() => {
      this.isInitialized = true;
    });
  },
  methods: {
    ...mapActions('questionaryList', { fetchData: 'fetchQuestionaryList' }),
    ...mapActions('questionaryDetails', ['deleteQuestionary']),
    onDelete() {
      this.fetchData(this.paginationParams).then(() => {
        this.isInitialized = true;
      });
    },
    onRefresh() {
      this.fetchData(this.paginationParams).then(() => {
        this.isInitialized = true;
      });
    },
    onNewQuestionary() {
      this.isNewQuestionaryDialogDisplayed = true;
    },
  },
};
</script>

<template>
  <div>
    <v-toolbar dark dense height="40" color="blue-grey lighten-2">
      <v-tooltip bottom>
        <v-btn @click="onNewQuestionary" icon slot="activator">
          <v-icon>add</v-icon>
        </v-btn>
        <span>Neu</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn @click="onRefresh" icon slot="activator">
          <v-icon>refresh</v-icon>
        </v-btn>
        <span>Aktualisieren</span>
      </v-tooltip>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="questionaryList.data"
      :disable-initial-sort="true"
      :pagination="pagination"
      :loading="questionaryList.isLoading"
      :rows-per-page-items="rowsPerPageItems"
      :total-items="pagination.totalItems"
      :expand="true"
      item-key="id"
      @update:pagination="loadNextPage"
      rows-per-page-text="Zeilen pro Seite"
      no-data-text="keine Daten verfügbar"
      class="elevation-1 js-table"
    >
      <template slot="items" slot-scope="props">
        <questionary-list-item
          :questionary="props.item"
          :expanded="props.expanded"
          @delete="onDelete"
        />
      </template>
      <template slot="pageText" slot-scope="{ pageStart, pageStop }">
        von {{ pageStart }} bis {{ pageStop }}
      </template>
    </v-data-table>

    <NewQuestionaryDialog
      v-if="isNewQuestionaryDialogDisplayed"
      @submit="isNewQuestionaryDialogDisplayed = false"
      @cancel="isNewQuestionaryDialogDisplayed = false" />
  </div>
</template>

<style lang="scss" scoped>

</style>
